import { AxiosResponse } from 'axios';
import apiClient from './apiClient';
import { Config } from '../config';

export const getAllSubscriptionPlans = async (params: {
  email: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<any>(
    Config.endPoint.getSubscriptionPlans,
    params
  );
  return response;
};

export const createPaymentForPlan = async (params: {
  email: string;
  planId: string;
  country: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<any>(
    Config.endPoint.createPaymentForPlan,
    params
  );
  return response;
};
